import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import api from '../utils/api';

export default function ResetPassword() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) return setError('Passwords do not match');
        
        setLoading(true);
        setError('');
        try {
            await api.post('/api/auth/reset-password', { token, password });
            setMessage('Password reset successful! Redirecting to login...');
            setTimeout(() => navigate('/login'), 3000);
        } catch (err) {
            setError(err.response?.data?.error || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    if (!token) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-900 text-white p-4">
                <div className="text-center glass p-10 rounded-3xl border border-white/10">
                    <h1 className="text-2xl font-bold text-rose-400 mb-4">Invalid Link</h1>
                    <p className="text-slate-400 mb-6">This password reset link is invalid or has expired.</p>
                    <Link to="/login" className="text-emerald-400 hover:underline">Return to Login</Link>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-slate-900">
            <div className="glass p-8 rounded-3xl max-w-md w-full border border-white/10 shadow-2xl relative">
                <h1 className="text-3xl font-bold mb-2 bg-clip-text text-transparent bg-gradient-to-r from-emerald-400 to-cyan-400 mt-4">New Password</h1>
                <p className="text-slate-400 mb-8">Secure your account with a new password</p>

                {error && <div className="bg-rose-500/20 text-rose-400 p-3 rounded-xl mb-6 text-sm border border-rose-500/30">{error}</div>}
                {message && <div className="bg-emerald-500/20 text-emerald-400 p-3 rounded-xl mb-6 text-sm border border-emerald-500/30">{message}</div>}

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-slate-400 mb-2">New Password</label>
                        <input 
                            type="password" 
                            required 
                            minLength="8"
                            className="w-full bg-slate-800 border border-slate-700 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-emerald-500 transition"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-slate-400 mb-2">Confirm New Password</label>
                        <input 
                            type="password" 
                            required 
                            className="w-full bg-slate-800 border border-slate-700 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-emerald-500 transition"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </div>
                    <button 
                        type="submit" 
                        disabled={loading}
                        className="w-full py-3 bg-gradient-to-r from-emerald-500 to-cyan-500 hover:from-emerald-400 hover:to-cyan-400 text-white font-bold rounded-xl shadow-lg transition-all active:scale-95 disabled:opacity-50"
                    >
                        {loading ? 'Resetting...' : 'Update Password'}
                    </button>
                </form>
            </div>
        </div>
    );
}
